import { ContactForm } from "../components/contact/ContactForm";
import { useClipboard } from "../hooks/useClipboard";
import { site } from "../data/site";
import { trackClick } from "../lib/trackVisit";
export function Contact() {
  const { copyState, copyEmail } = useClipboard(site.email);
  return (
    <section id="contact" className="contact-section">
      <div className="shell">
        <div className="contact-top">
          <span className="eyebrow">05 / LET’S TALK</span>
          <span className="contact-small">
            A NEW PRODUCT. A HARD PROBLEM.
            <br />A TEAM THAT CARES ABOUT THE DETAILS.
          </span>
        </div>
        <h2 data-reveal>
          Let’s build
          <br />
          something <em>good.</em>
          <span className="contact-asterisk" aria-hidden="true">
            ✳
          </span>
        </h2>
        <div className="contact-grid">
          <div className="contact-details" data-reveal>
            <p>
              Have a project in mind or a role you think I’d fit? I’d like to
              hear about it.
            </p>
            <a className="email-link" href={`mailto:${site.email}`}>
              {site.email} ↗
            </a>
            <button type="button" className="copy-email" onClick={copyEmail}>
              {copyState || "Copy email address +"}
            </button>
            <span className="sr-only" role="status">
              {copyState}
            </span>
            <div className="social-links">
              <a href={site.github} target="_blank" rel="noreferrer" onClick={() => trackClick("github")}>
                GitHub ↗
              </a>
              <a href={site.linkedin} target="_blank" rel="noreferrer" onClick={() => trackClick("linkedin")}>
                LinkedIn ↗
              </a>
              <a href="/Resume.pdf" download onClick={() => trackClick("resume")}>
                Resume ↗
              </a>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
